export enum PDateTimeRangeInputFieldLayout {
  AUTO = 'auto',
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}
